// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__3rq-7","errorLogs":"styles_errorLogs__25yiD"};